import { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useNavigate, Link } from 'react-router-dom';
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';

const NotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const pageDetails = {
        title: "404 - Page **Not Found**",
        description: "The page you are looking for does not exist or has been moved.",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: "404", link: "/404" }
        ],
    };

    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                <section className='py-5'>
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8} className="text-center">
                                <div style={{ padding: '60px 20px' }}>
                                    {/* 404 Number */}
                                    <h1 style={{
                                        fontSize: '120px',
                                        fontWeight: 'bold',
                                        color: '#677a58',
                                        lineHeight: '1',
                                        marginBottom: '20px'
                                    }}>
                                        404
                                    </h1>

                                    {/* Error Message */}
                                    <h2 style={{
                                        fontSize: '36px',
                                        fontWeight: '600',
                                        color: '#212529',
                                        marginBottom: '20px'
                                    }}>
                                        Page Not Found
                                    </h2>

                                    <p style={{
                                        fontSize: '18px',
                                        color: '#6c757d',
                                        marginBottom: '40px',
                                        lineHeight: '1.6'
                                    }}>
                                        Sorry, the page you are looking for does not exist or has been moved.
                                        <br />
                                        Please check the URL or return to the homepage.
                                    </p>

                                    {/* Action Buttons */}
                                    <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                                        <Button
                                            onClick={() => navigate('/')}
                                            backgroundColor="#677a58"
                                            color="#ffffff"
                                            hoverBackgroundColor="#5a6a4a"
                                            borderRadius="8px"
                                            padding="12px 30px"
                                            fontSize="16px"
                                            fontWeight="600"
                                            minWidth="180px"
                                            icon="fa fa-home me-2"
                                        >
                                            Go to Homepage
                                        </Button>

                                        <Button
                                            variant="outline"
                                            onClick={() => navigate(-1)}
                                            borderColor="#677a58"
                                            color="#677a58"
                                            hoverBackgroundColor="#677a58"
                                            hoverColor="#ffffff"
                                            borderRadius="8px"
                                            padding="12px 30px"
                                            fontSize="16px"
                                            fontWeight="600"
                                            minWidth="180px"
                                            borderWidth="2px"
                                            icon="fa fa-arrow-left me-2"
                                        >
                                            Go Back
                                        </Button>
                                    </div>

                                    {/* Quick Links */}
                                    <div style={{ marginTop: '60px', paddingTop: '40px', borderTop: '1px solid #e9ecef' }}>
                                        <h5 style={{
                                            fontSize: '20px',
                                            fontWeight: '600',
                                            color: '#212529',
                                            marginBottom: '25px'
                                        }}>
                                            Popular Pages
                                        </h5>
                                        <div className="d-flex flex-wrap gap-3 justify-content-center">
                                            <Link 
                                                to="/" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                Home
                                            </Link>
                                            <Link 
                                                to="/services" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                Services
                                            </Link>
                                            <Link 
                                                to="/our-pricing" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                Pricing
                                            </Link>
                                            <Link 
                                                to="/portfolio" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                Portfolio
                                            </Link>
                                            <Link 
                                                to="/about-us" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                About Us
                                            </Link>
                                            <Link 
                                                to="/contact-us" 
                                                style={{
                                                    color: '#677a58',
                                                    textDecoration: 'none',
                                                    fontSize: '15px',
                                                    fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                Contact Us
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </>
    );
};

export default NotFound;

